import { useState, useEffect } from "react";
import useGoogleMapsLoader from "./useGoogleMapsLoader";

const useGeocode = (lat, lng) => {
    const [placeName, setPlaceName] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const { isLoaded } = useGoogleMapsLoader();

    useEffect(() => {
        if (!isLoaded || !lat || !lng) return;

        const geocodeLocation = async () => {
            setIsLoading(true);
            setError(null);

            try {
                const geocoder = new window.google.maps.Geocoder();
                const latLng = new window.google.maps.LatLng(lat, lng);

                const results = await new Promise((resolve, reject) => {
                    geocoder.geocode({ location: latLng }, (results, status) => {
                        if (status === window.google.maps.GeocoderStatus.OK) {
                            resolve(results);
                        } else {
                            reject(status);
                        }
                    });
                });

                if (results?.[0]) {
                    const address = results[0].formatted_address;
                    let city = "";
                    let governorate = "";

                    results[0].address_components.forEach((component) => {
                        if (component.types.includes("locality")) {
                            city = component.long_name;
                        }
                        if (component.types.includes("administrative_area_level_2") && !city) {
                            city = component.long_name;
                        }
                        if (component.types.includes("administrative_area_level_1")) {
                            governorate = component.long_name;
                        }
                    });
                    const name = city && governorate ? `${city}, ${governorate}` : address;
                    setPlaceName(name);
                } else {
                    setError("No results found");
                }
            } catch (err) {
                setError(
                    err instanceof Error ? err.message : "Geocoding failed due to an unknown error"
                );
            } finally {
                setIsLoading(false);
            }
        };

        geocodeLocation();
    }, [lat, lng, isLoaded]);

    return { placeName, isLoading, error };
};

export default useGeocode;
